import {
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import filterIcon from "../../assets/images/filter-icon.svg";
import { useTranslation } from "react-i18next";

export default function CheckInTimeSelect({ data, handleOrderingChange }) {
  const [selectedItem, setSelectedItem] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { t } = useTranslation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (item) => {
    setAnchorEl(null);
    setSelectedItem(item);
  };

  useEffect(() => {
    if (selectedItem) {
      handleOrderingChange(selectedItem);
    }
  }, [selectedItem]);

  return (
    <div style={{ width: "100px", display: "flex", flexDirection: "row", alignItems: "center" }}>
      {t("check_in_time")}
      <IconButton sx={{ padding: "0 5px" }} onClick={handleClick}>
        <img src={filterIcon} alt="" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {data.map((item) => (
          <MenuItem key={item.id} onClick={() => handleClose(item)}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
